import React, { useState } from 'react';
import PropTypes from 'prop-types';
import config from '../../../../config';
import { sessionTypes } from '../../../utils/constants';

import SectionHeading from '../../../components/text/SectionHeading';
import SectionHeadingWrapper from '../../../components/text/SectionHeading/HeadingWrapper';

const LeagueTeams = ({ teams = [], title, 'data-testid': dataTestId }) => {
    const [showAll, setShowAll] = useState();

    return (
        <>
            {(teams?.length > 0) ? (
                <>
                    <div className="row mt64">
                        <div className="col-12">
                            <SectionHeadingWrapper>
                                <SectionHeading title={title} data-testid={dataTestId && `${dataTestId}.section-heading`} />
                                {teams.length > 3 && (
                                    <div className={`link clickable`} onClick={() => setShowAll(!showAll)} data-testid={dataTestId && `${dataTestId}.view-toggle`}>
                                        {showAll ? 'View Less' : 'View All'}
                                    </div>
                                )}
                            </SectionHeadingWrapper>
                        </div>
                    </div>
                    <div className="row">
                        {teams.map((team, index) => {
                            const { teamId, sessionName, sessionTypeId, teamName, teamMatchLosses, teamMatchWins } = team;
                            const sessionType = sessionTypes.find((type) => type.id === sessionTypeId);
                            if (index <= 2 || (index > 2 && showAll)) {
                                return (
                                    <div
                                        className={`col-12 col-md-6 col-xl-4 mb10`}
                                        key={teamId}
                                    >
                                        <a href={`${config.leaguesAppHost}/teams/${teamId}`} data-testid={dataTestId && `${dataTestId}.item-${teamId}.link`}>
                                            <div className="league-team-card">
                                                <div className="content-wrapper">
                                                    <div className="title ellipsis" data-testid={dataTestId && `${dataTestId}.item-${teamId}.name`}>{`${teamName} (${teamMatchWins}-${teamMatchLosses})`}</div>
                                                    <div className="d-flex flex-row jcfs">
                                                        <div className="text-normal session-type mr4" data-testid={dataTestId && `${dataTestId}.item-${teamId}.session-type`}>{`${sessionType.description} \u2022  `}</div>
                                                        <div className="session-name mr4 flex-1 ellipsis" data-testid={dataTestId && `${dataTestId}.item-${teamId}.session-name`}>{sessionName}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                );
                            }
                            return <div key={teamId} />;
                        })}
                    </div>
                </>
            ) : null}
        </>
    );
};

LeagueTeams.propTypes = {
    teams: PropTypes.instanceOf(Array),
    title: PropTypes.string,
};

LeagueTeams.defaultProps = {
    teams: [],
    title: null,
};

export default LeagueTeams;
